class TileListWithContentController {
    constructor(pageBannerStateService) {
        this.pageBannerStateService = pageBannerStateService;
    }
}

const tileListWithContentComponentDefinition = {
    transclude: true,
    controller: ['PageBannerStateService', TileListWithContentController],
    template: require('./tile-list-with-content.component.html').trim(),
};

module.exports = {
    TileListWithContentController,
    tileListWithContentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/tile-list-with-content.component.js